export const validateCheckoutForm = (formData) => {
  const normalized = Object.fromEntries(
    Object.entries(formData).map(([key, value]) => [key, String(value || '').trim()])
  );
  const errors = {};

  if (!normalized.customer_name) errors.customer_name = 'Enter the recipient’s full name.';
  else if (normalized.customer_name.length > 120) errors.customer_name = 'Use 120 characters or fewer.';

  if (!normalized.customer_email) errors.customer_email = 'Enter an email address.';
  else if (!/^\S+@\S+\.\S+$/.test(normalized.customer_email)) errors.customer_email = 'Enter a valid email address.';

  if (normalized.customer_phone && !/^[+()\d\s-]{7,20}$/.test(normalized.customer_phone)) {
    errors.customer_phone = 'Enter a valid phone number or leave this field blank.';
  }

  if (!normalized.shipping_address) errors.shipping_address = 'Enter a street address.';
  else if (normalized.shipping_address.length > 240) errors.shipping_address = 'Use 240 characters or fewer.';

  if (!normalized.shipping_city) errors.shipping_city = 'Enter a city.';
  else if (normalized.shipping_city.length > 80) errors.shipping_city = 'Use 80 characters or fewer.';

  if (!normalized.shipping_state) errors.shipping_state = 'Enter a state or region.';
  else if (normalized.shipping_state.length > 80) errors.shipping_state = 'Use 80 characters or fewer.';

  if (!normalized.shipping_zip) errors.shipping_zip = 'Enter a postal code.';
  else if (!/^[A-Za-z0-9 -]{3,12}$/.test(normalized.shipping_zip)) errors.shipping_zip = 'Enter a valid postal code.';

  if (!normalized.shipping_country) errors.shipping_country = 'Enter a country.';
  else if (normalized.shipping_country.length > 80) errors.shipping_country = 'Use 80 characters or fewer.';

  return { normalized, errors };
};
